import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Youtube = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 40.578H10a10 10 0 0 1-10-10v-20a10 10 0 0 1 10-10h20a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10Z"
      fill="red"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 11.828H30A5.625 5.625 0 0 0 30.575.607c-.191-.01-.38-.029-.575-.029H10a10 10 0 0 0-10 10v20a18.75 18.75 0 0 1 18.75-18.75Z"
      fill="#FF5A51"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 20.578a10 10 0 1 0 10 10v-20a10 10 0 0 1-10 10Z"
      fill="#D5002C"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.655 11.751a1.249 1.249 0 0 0-1.905 1.065v15.526a1.25 1.25 0 0 0 1.905 1.064c3.187-1.96 9.55-5.876 12.615-7.763a1.251 1.251 0 0 0 0-2.129 90734.43 90734.43 0 0 0-12.615-7.763Z"
      fill="#fff"
    />
  </Svg>
)

export default Youtube
